import React, { useState, useRef, useEffect } from 'react'
import { ReactComponent as RightArrow } from '../../icon/right-arrow.svg'
import { ReactComponent as LeftArrow } from '../../icon/left-arrow.svg'
import Theme from '../../library/Theme'
import { PresetImage } from '../../library/Preset'

interface OverlaysToolbarProps {
  theme: Theme
  overlays: PresetImage[]
  background: string
  handleSelect: (index: number, overlay: PresetImage) => void
}

export default function OverlaysToolbar({ theme, overlays, background, handleSelect}: OverlaysToolbarProps) {
  const [showControls, setShowControls] = useState(true)
  const [enableLeftControl, setEnableLeftControl] = useState(false)
  const [enableRightControl, setEnableRightControl] = useState(false)
  const toolbarRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    updateControls()
  })

  const scroll = (x: number) => {
    let toolbar = toolbarRef.current
    if (!toolbar) {
      return
    }
    toolbar.scrollLeft += x
  }

  const updateControls = () => {
    let toolbar = toolbarRef.current
    if (!toolbar) {
      return
    }

    setEnableLeftControl(toolbar.scrollLeft > 0)
    setEnableRightControl(toolbar.scrollLeft + toolbar.clientWidth < toolbar.scrollWidth)
    setShowControls(toolbar.clientWidth < toolbar.scrollWidth)
  }

  const scrollAmount = toolbarRef.current ? toolbarRef.current.clientWidth / 2 : 100

  return (
    <div className="toolbarContainer">
      {showControls &&
        <div className={"controlButton" + (enableLeftControl ? "" : " disabled")} style={theme.buttonStyle} onClick={(x) => scroll(-scrollAmount)}>
          <LeftArrow style={theme.svgStyle} />
        </div>
      }
      <div ref={toolbarRef} className="toolbar" onScroll={updateControls}>
        {overlays.map((overlay, index) =>
          <div className="toolbarItem" key={index} style={{ backgroundImage: "url(" + background + ")" }}>
            <img
              crossOrigin="anonymous"
              src={overlay.url}
              alt={"Overlay " + index}
              onLoad={updateControls}
              onClick={(e) => handleSelect(index, overlay)}
            />
          </div>
        )}
      </div>

      {showControls &&
        <div className={"controlButton" + (enableRightControl ? "" : " disabled")} style={theme.buttonStyle} onClick={(x) => scroll(scrollAmount)}>
          <RightArrow style={theme.svgStyle} />
        </div>
      }
    </div>
  )
}
